module.exports = __webpack_public_path__ + "static/img/14.c4fb6bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/14.png
// module id = OgDc
// module chunks = 0